import React, { Component, PropTypes } from 'react';
import { SparkProgressIndicator } from '../ui/spark';

class ReactSparkProgressIndicator extends Component {
    static propTypes = {
        progress: PropTypes.number,
        indeterminate: PropTypes.bool
    };
    static defaultProps = {
        progress: 0,
        indeterminate: false
    };
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        if (this.progressBarRef) {
            this.progressBarInstance = new SparkProgressIndicator(this.progressBarRef);
        }
    }
    componentWillUnmount() {
        if (this.progressBarInstance) {
            if (typeof this.progressBarInstance.remove === 'function') this.progressBarInstance.remove(true);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.progressBarInstance && nextProps.progress) {
            this.progressBarInstance.set(nextProps.progress / 100);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        //we dont need redraw it, just use intance to set progress
        return !nextProps.progress;
    }
    render() {
        return (
            <div
                ref={node => (this.progressBarRef = node)}
                className="spark-progress spark-progress--integrated spark-progress--lg"
                role="progressbar"
            >
                <progress value={this.props.indeterminate ? null : this.props.progress / 100}></progress>
                <span className="spark-progress__text">
                    <span className="spark-progress__value" role="status">
                        {this.props.indeterminate ? 'Uploading...' : `${this.props.progress}%`}
                    </span>
                </span>
                <span className="spark-progress__meter"></span>
            </div>
        );
    }
}

export default ReactSparkProgressIndicator;



// WEBPACK FOOTER //
// ./src/components/widgets/ReactSparkProgressIndicator.js